export default {
  init() {
    // JavaScript to be fired
    $(document).on('click', '.flip-card .btn-flip, .flip-card .card-image-flip', function (e) {
      e.preventDefault();

      const thisFlipCard = $(e.target).closest('.flip-card-container');

      $('.flip-card-container').removeClass('wrapper-flipped');
      thisFlipCard.addClass('wrapper-flipped');
      $('.flip-card-container .flip-card-wrapper').removeClass('card-flipped');
      thisFlipCard.find('.flip-card-wrapper').addClass('card-flipped');

      return false;
    });

    $(document).on('click', '.flip-card .btn-unflip', function (e) {
      e.preventDefault();

      const thisFlipCard = $(e.target).closest('.flip-card');

      thisFlipCard.closest('.card-wrapper').removeClass('wrapper-flipped');
      thisFlipCard.find('.flip-card-wrapper').removeClass('card-flipped');

      return false;
    });
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/components/flipCard.js